import React from 'react';
import styles from './index.module.scss';
import startCase from 'lodash/startCase';
import capitalize from 'lodash/capitalize';
import PropTypes from 'prop-types';
import Image from 'components/Image';
import Activity from 'components/Details/Activity';
import valueType from 'components/Details';
import addImage from 'images/icon_add_profile_image.svg';
import cn from 'classnames';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { getHiddenFieldIfNotEnabled } from 'utils/helper/product';
import { getSecurityCompanyFeatures } from '../../reducers/securityCompany';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { areGlobalDepartmentRecordsEmpty } from 'selectors/globalSelectors';

const useStyles = makeStyles(theme => ({
  key: {
    color: theme.palette.text.secondary,
    flex: '1 1 50%',
    display: 'flex',
    minWidth: '6rem',
    boxSizing: 'border-box',
    textAlign: '-webkit-left',
    alignItems: 'flex-end',
  },
}));

export const ImageHolder = ({ src }) => {
  return (
    <div key={src} className={styles.imageContainer}>
      <Image
        className={styles.clientImage}
        src={src != null ? src : addImage}
      />
    </div>
  );
};

ImageHolder.propTypes = {
  src: PropTypes.string,
};

const DetailGeneralInfo = ({ data, imageSrc, status, className, display }) => {
  const classes = useStyles();
  const subscribedFeatures = useSelector(state =>
    getSecurityCompanyFeatures(state),
  );
  const areDepartmentsAvailable = useSelector(state =>
    areGlobalDepartmentRecordsEmpty(state),
  );
  // checks if a column field in Aggrid need to be hidden depending on a feature
  const isDepartmentsEnabled = getHiddenFieldIfNotEnabled({
    subscribedFeatures,
    feature: 'DEPARTMENTS',
    field: 'departments',
    areDepartmentsAvailable,
  });

  // Add here if you want to programatically hide fields based on feature
  const hiddenColumns = [isDepartmentsEnabled];

  return (
    <div className={cn(styles.detailValue, className)}>
      {imageSrc && (
        <div className={styles.clientImageContainer}>
          {Array.isArray(imageSrc) ? (
            imageSrc.map(image => {
              return (
                <ImageHolder
                  key={image.value}
                  className={styles.clientImage}
                  src={image.value ? image.value : addImage}
                />
              );
            })
          ) : (
            <ImageHolder
              className={styles.clientImage}
              src={imageSrc.value ? imageSrc.value : addImage}
            />
          )}
          {status && (
            <div className={styles.activity}>
              <Activity
                className={styles.status}
                value={status.idValue}
                alt=""
              />
              <p className={styles.statusText}>{t(capitalize(status.value))}</p>
            </div>
          )}
        </div>
      )}

      <div className={styles.detailContainer}>
        {Object.keys(data).map(key => {
          //check if hidden column field matches the field name in the column and hide field should be true
          const requiredHiddenField = hiddenColumns.find(
            x => key === x.field && x.hide,
          );

          return (
            <div
              className={cn(styles.detailData, styles[display])}
              key={`${key}${key}`}
            >
              {data[key] && !data[key].hideLabel && !requiredHiddenField ? (
                <Box component={'div'} className={classes.key} key={key}>
                  {t(data[key].label) || t(startCase(key))}
                </Box>
              ) : null}
              {!requiredHiddenField && (
                <Box component={'div'} key={data[key]} className={styles.value}>
                  {valueType(data[key])}
                </Box>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

DetailGeneralInfo.propTypes = {
  data: PropTypes.object.isRequired,
  imageSrc: PropTypes.object,
  status: PropTypes.object,
  className: PropTypes.string,
  display: PropTypes.string,
  translation: PropTypes.func,
};
export default DetailGeneralInfo;
